import React, { useState, useEffect, useRef } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

import "../styles/Customers.scss";

import ArrowBackIosOutlinedIcon from "@material-ui/icons/ArrowBackIosOutlined";
import ArrowForwardIosOutlinedIcon from "@material-ui/icons/ArrowForwardIosOutlined";

import bmwLogoSrc from "../images/bmw.png";
import adidasLogoSrc from "../images/adidas.png";
import bershkaLogoSrc from "../images/bershka.png";
import kfcLogoSrc from "../images/kfc.png";
import lidlLogoSrc from "../images/lidl.png";
import shureLogoSrc from "../images/shure.png";
import stradivariusLogoSrc from "../images/stradivarius.png";
import onetLogoSrc from "../images/onet.png";

gsap.registerPlugin(ScrollTrigger);
const customers = [
  { id: 0, imgSrc: bmwLogoSrc, desc: "BMW Logo" },
  { id: 1, imgSrc: adidasLogoSrc, desc: "Adidas Logo" },
  { id: 2, imgSrc: bershkaLogoSrc, desc: "Bershka Logo" },
  { id: 3, imgSrc: kfcLogoSrc, desc: "KFC Logo" },
  { id: 4, imgSrc: lidlLogoSrc, desc: "Lidl Logo" },
  { id: 5, imgSrc: shureLogoSrc, desc: "Shure Logo" },
  { id: 6, imgSrc: stradivariusLogoSrc, desc: "Stradivarius Logo" },
  { id: 7, imgSrc: onetLogoSrc, desc: "Onet Logo" },
];

function Customers() {
  const [sliderIndex, setSliderIndex] = useState(0);
  const divRef = useRef(null);

  useEffect(() => {
    const div = divRef.current.children;
    gsap.fromTo(
      div,
      { x: "-=300", autoAlpha: 0 },
      {
        duration: 0.5,
        x: "+=300",
        autoAlpha: 1,
        ease: "none",
        scrollTrigger: {
          id: "customers",
          trigger: div,
          start: "top center",
        },
      }
    );
  }, []);

  const handleBackClick = () => {
    if (sliderIndex === 0) {
    } else {
      setSliderIndex(sliderIndex - 1);
    }
  };

  const handleForwardClick = () => {
    if (sliderIndex === customers.length - 4) {
    } else {
      setSliderIndex(sliderIndex + 1);
    }
  };

  return (
    <div className="customersContainer" id="clients" ref={divRef}>
      <h3>Trusted by over 100+ happy customers</h3>
      <div className="slider">
        <ArrowBackIosOutlinedIcon className="arrow" onClick={handleBackClick} />
        {customers.slice(sliderIndex, sliderIndex + 4).map((customer) => (
          <img src={customer.imgSrc} alt={customer.desc} key={customer.id} />
        ))}
        <ArrowForwardIosOutlinedIcon
          className="arrow"
          onClick={handleForwardClick}
        />
      </div>
    </div>
  );
}

export default Customers;
